import { useQuery } from "@tanstack/react-query";

import { subscriptionQueryOptions } from "@/domains/subscriptions/factories/subscription-query-options";

export const useSubscriptionLink = (enabled: boolean) => {
  return useQuery({
    ...subscriptionQueryOptions.link,
    enabled,
  });
};
